// src/assets/archetypeAssets.ts
import momentProposalBgImg from "./img/archetypes/moment3.png";
import momentLetterBgImg from "./img/archetypes/moment_bg.jpg";
import heartbeatProposalBgImg from "./img/archetypes/heartbeat2.png";
import heartbeatLetterBgImg from "./img/archetypes/heartbeat_bg.png";
import safehavenProposalBgImg from "./img/archetypes/safehaven.png";
import safehavenLetterBgImg from "./img/archetypes/safehaven_bg.jpg";

export interface ArchetypeAssetMap {
  proposalBgImage: string;
  letterBgImage: string;
}

export const ArchetypeAssets: Record<string, ArchetypeAssetMap> = {
  moments: {
    proposalBgImage: momentProposalBgImg,
    letterBgImage: momentLetterBgImg,
  },
  heartbeat: {
    proposalBgImage: heartbeatProposalBgImg,
    letterBgImage: heartbeatLetterBgImg,
  },
  safehaven: {
    proposalBgImage: safehavenProposalBgImg,
    letterBgImage: safehavenLetterBgImg,
  },
};
